import { useCallback, useRef } from 'react';
export function useCompositeComponentFocusHandlers(_a) {
    var onFocus = _a.onFocus, onBlur = _a.onBlur, name = _a.name, _b = _a.blurForNonFocusableElementsWithin, blurForNonFocusableElementsWithin = _b === void 0 ? true : _b;
    var isFocusedRef = useRef(false);
    var callOnBlur = useCallback(function () {
        onBlur === null || onBlur === void 0 ? void 0 : onBlur({ name: name, type: 'blur' });
        isFocusedRef.current = false;
    }, [onBlur, name]);
    var blurHandler = useCallback(function (e) {
        if (!e.currentTarget.contains(e.relatedTarget)) {
            callOnBlur();
        }
    }, [callOnBlur]);
    var focusHandler = useCallback(function (e) {
        if (!e.currentTarget.contains(e.relatedTarget) &&
            /* checking the ref because relatedTarget can
             * be null in case of DOM elements that are removed
             * (e.g. DatePicker change month). */
            !isFocusedRef.current) {
            onFocus === null || onFocus === void 0 ? void 0 : onFocus({ name: name, type: 'focus' });
            isFocusedRef.current = true;
        }
    }, [onFocus, name]);
    var returns = {
        rootCompositeFocusProps: {
            onFocus: focusHandler,
            onBlur: blurHandler,
        },
        compositeBlur: callOnBlur,
    };
    if (!blurForNonFocusableElementsWithin) {
        returns.rootCompositeFocusProps.tabIndex = -1;
    }
    return returns;
}
//# sourceMappingURL=useCompositeComponentFocusHandlers.js.map